import * as T from 'i18next';
export function __(key: string, options?: any): string | any | Array<any> {
    return T.t(key, options);
}

export function __exists(
    key: string,
    options?: any,
): string | any | Array<any> {
    return T.exists(key, options);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/i18Abstract.ts